<!-- ***************************************************** Navigation Bar Section *************************************************** -->

<nav class="navbar navbar-inverse navbar-fixed-top" style="margin: 0;">
    <div class="container-fluid">
      <div class="col-sm-4">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#companyNavBar">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <!-- <a class="navbar-brand" (click)="scroll(introSec)" style="cursor: pointer;">Seng Hin Rubber</a> -->
          <!-- <img class="navbar-logo" src="../../assets/images/SHR_banner.png" (click)="scroll(introSec)" style="cursor: pointer;"> -->
          <div class="navbar-logo" (click)="scroll(introSec)" style="cursor: pointer;"></div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="collapse navbar-collapse" id="companyNavBar">
          <ul class="nav navbar-nav company-nav">
            <li><a data-target=".navbar-collapse.show" data-toggle="collapse" (click)="scroll(about)">About</a></li>
            <li><a data-target=".navbar-collapse.show" data-toggle="collapse" (click)="scroll(goal)">Goals</a></li>
            <li><a data-target=".navbar-collapse.show" data-toggle="collapse" (click)="scroll(product)">Products</a></li>
            <li><a data-target=".navbar-collapse.show" data-toggle="collapse" (click)="scroll(sustainability)">Sustainability</a></li>
            <li><a data-target=".navbar-collapse.show" data-toggle="collapse" (click)="scroll(contact)">Contact</a></li>
          </ul>
          <!-- <div class="language" *ngIf="translateCheck(); else enBlock" style="float:right; padding: 10px;"><a href="http://localhost:4200/home" style="color: grey;">EN</a><span> | </span><a style="color: white;">CN</a></div> -->
              <!-- <ng-template #enBlock><div class="language" style="float: right; padding: 10px;"><a style="color: white;">EN</a><span> | </span><a style="color:grey;" href="http://localhost:4201/zh/home">CN</a></div></ng-template> -->
        </div>
      </div>   
    </div>
  </nav>

<!-- ************************************************** Company Introduction Section ************************************************* -->

<!-- <video autoplay muted loop class="introBackgroundVideo">
  <source src="../../assets/images/DCIM/VID_20210410_123615.mp4" type="video/mp4">  
</video> -->

<div class="company-intro" #introSec>
  <div class="intro-content">
    <div class="company-name"  [@introIn]>
      <img class = "company-img" src="assets/images/Logo/company-logo-3.png"><h1>Seng Hin Rubber (M) Sdn. Bhd.<br/><span style="font-style: italic;">A Member of Southland Rubber Group</span></h1>
      <br><br><br>
    </div>
  
    <div class="company-description" [@introDescIn]>
      <!-- <h3 i18n="Company Intro">We are one of the top Rubber Manufacturers in Asia.</h3>
      <h3>In terms of quality, price and sustainability, we are always second to no one.</h3> -->
      <h3 i18n="Company Intro">A Reliable and Dependable Supplier of Quality Natural Rubber You can Trust.</h3>
      <h3></h3>
      <div class="social-section-intro">
        <div class="social-icon-1 col-sm-6" (click)="redirectToFb()"></div>
        <div class="social-icon-2 col-sm-6" (click)="redirectToLink()"></div>
      </div>
    </div>  
  </div>
</div>

<!-- ********************************************************** About Section ******************************************************** -->
<div #about class="about-detail">
  <div class="content col-sm-7">
    <h1 [@movingIn]="abt ? 'afterTitle':'beforeTitle'" #aboutSec>About Us</h1>  

    <p>We ought to see innovative and quality production from every production field. With the supply from trusted
      suppliers, we clean, process, manufacture and test before putting on sale to ensure the quality meet the standard </p>
    <br>

    <p>Other than rubber manufacturing, we also put a lot of efforts in taking good care of our mother nature. The whole process
      of rubber manufacturing in Seng Hin Rubber is keeping revised and revised so that the byproducts could be reduced, reused and
      recycle to avoid putting our land in vain.
    </p>

    <div class="history-button" (click)="collapseExpand('history')">History</div>

    <div class="ISO-Cert"></div>
    <div class="Standard-Cert"></div>
    <div class="EcoVadis-Award"></div>
    
    <div class="established-year" #establishedYear>
      <!-- <div class="icon-down"></div> -->
      <div class="established-detail">
        <p>*We have been established since <span style="font-size: 40px; font-weight: bold;">1974</span>.</p>    
      </div>
      <!-- <div class="icon-down"></div> -->
    </div>
  </div>

  <div class="company-img-about col-sm-5"></div>

</div>

<!-- ********************************************************** History Section ******************************************************* -->

<div class="section-history" [@divCollapsed]="{value: historyCollapseString, params:{divHeight: expandHeight}}" #historyTab>
  <div class="history-timeline"></div>
  
  <div class="history-content-sec" (mouseenter)="historyHover = true" (mouseleave)="historyHover = false">
    
    <div class="history-content" #historyContent>
      <div class="content-1 hist-content">
        <h3 class="history-year">1952</h3>
  
        <div class="content-1-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/DCIM/old_site.jpg');"></div>
        </div>
    
        <p>Seng Hin Rubber started off as a Smoke House Operator producing Ribbed Smoked Sheet (RSS) for 15 years under Chop Seng Hin.</p>  
      </div>
  
      <div class="content-2 hist-content">
        <h3 class="history-year">1974</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/DCIM/IMG_20210418_152431.jpg');"></div>
        </div>
        <p>Seng Hin Rubber was then incoporated into a limited company in 29<sup>th</sup> November 1974 as Seng Hin Rubber (M) Sdn Bhd at Wakaf Che Yeh Kota Bharu Kelantan.</p>
      </div>
  
      <div class="content-2 hist-content">
        <h3 class="history-year">2004</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/DCIM/IMG_20210418_152431.jpg');"></div>
        </div>
        <p>Office and Production Field were shifted to Sg. Nal Industrial Estate in Kuala Krai under the State's Relocation Program.</p>
      </div>
  
      <div class="content-2 hist-content">
        <h3 class="history-year">2007</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/Logo/ISO17025.png');"></div>
        </div>
        <p>Our laboratory was accredited ISO/IEC 17025 in August 2007 showing the accuracy and quality of our rubber testing.</p>
      </div>
  
      <div class="content-2 hist-content">
        <h3 class="history-year">2008</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/Logo/LRQA-UKAS-logo.jpg');"></div>
        </div>
        <p>In terms of rubber productions, Seng Hin Rubber were first accredited with world class standard ISO 9001:2008 in July 2010.</p>
      </div>
  
      <div class="content-2 hist-content">
        <h3 class="history-year">2015</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/DCIM/IMG_20210426_160147.jpg');"></div>
        </div>
        <p>More production lines, machines, robotics and workforces were added as the increasing number of rubber demand in Seng Hin Rubber.</p>
      </div>

      <div class="content-2 hist-content">
        <h3 class="history-year">2018</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/southland.png');"></div>
        </div>
        <p>Partnership with <a class="southland" href="https://www.southlandholding.com/new/index.html" target="_blank">Southland Holding Company</a>, one 
        of the top rubber traders in Thailand.</p>
      </div>

      <div class="content-2 hist-content">
        <h3 class="history-year">2023</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/Logo/LRQA.png');"></div>
        </div>
        <p>World class standard ISO 14001 and ISO 45001 were accredited with our current ISO 9001:2008 in the early of 2023.</p>
      </div>

      <div class="content-2 hist-content">
        <h3 class="history-year">2023</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/Logo/ILAC-MRA.png');"></div>
        </div>
        <p>Our laboratory testing was acknowledged by ILAC Mutual Recognition Arrangement (ILAC MRA) in the early of 2023.</p>
      </div>

      <div class="content-2 hist-content">
        <h3 class="history-year">2023</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/Logo/EcoVadis-Certificate.png'); "></div>
        </div>
        <p>Acknowledgement from <a class="ecovadis" href="https://ecovadis.com/" target="_blank">EcoVadis</a> in our sustainability procurement policy with a bronze medal in April 2023.</p>
      </div>

      <div class="content-2 hist-content">
        <h3 class="history-year">Now - Future</h3>
        
        <div class="content-2-img history-img">
          <div class="history-content-img" style="background-image: url('assets/images/Logo/company-logo-2.JPG');"></div>
        </div>
        <p>Latest technology and more facilities are in planning to be implemented.</p>
      </div>
  
    </div>  

    <div class="left-button" [@historyButton]="historyHover ? 'hoverIn':'hoverOut'" (click)="scrollHorizontal('left')"><div class="glyphicon glyphicon-chevron-left"></div></div>
    <div class="right-button" [@historyButton]="historyHover ? 'hoverIn':'hoverOut'" (click)="scrollHorizontal('right')"><div class="glyphicon glyphicon-chevron-right"></div></div>
  </div>
</div>

<!-- *********************************************************** Goals Section ******************************************************** -->
<div #goal class="section-goal">
  <div class="goal-title" [@movingIn]="goals ? 'afterTitle':'beforeTitle'" #goalSec>
    <h1>Our Goals</h1>
  </div>

  <div class="goal-detail" [@movingIn]="goalDesc ? 'afterSec':'beforeSec'" #goalContent>
    <div class="product-quality col-sm-4" (mouseover)="goalHover1 = true" (mouseout)="goalHover1 = false">
      <div class="quality-icon" [@goalHover]="goalHover1 ? 'goal1Icon':'beforeHover'"></div>
        
      <div class="quality-words" [@goalHover]="goalHover1 ? 'fontHover':'beforeHover'">
        <div class="quality-title">
          <h4>Quality Products</h4>
        </div>
  
        <div class="quality-description">
          <p>We provide customers satisfaction through total dedication to quality! With ISO certification, it proves our professional management 
            and quality production.
          </p>
        </div>
      </div>
    </div>
      
    <div class="environment-green col-sm-4" (mouseover)="goalHover2 = true" (mouseout)="goalHover2 = false">
      <div class="environment-icon" [@goalHover]="goalHover2 ? 'goal2Icon':'beforeHover'"></div>

      <div class="environment-words" [@goalHover]="goalHover2 ? 'fontHover':'beforeHover'">
        <div class="environment-title">
          <h4>Environment Green</h4>
        </div>
  
        <div class="environment-description">
          <p>We manufacture while we care! With our environmental initiatives, we have considered the environment health
             well as a step toward the world we seek.</p>
        </div>
      </div>    
    </div>

    <div class="innovation col-sm-4" (mouseover)="goalHover3 = true" (mouseout)="goalHover3 = false">
      <div class="innovation-icon" [@goalHover]="goalHover3 ? 'goal3Icon':'beforeHover'"></div>

      <div class="innovation-words" [@goalHover]="goalHover3 ? 'fontHover':'beforeHover'">
        <div class="innovation-title">
          <h4>Innovation</h4>
        </div>
  
        <div class="innovation-description">
          <p>We empower all employees to develop and utilize innovativeness. We believe that they are the one bringing us the future that we are looking for!</p>
        </div>  
      </div>
    </div>

    <div class="productivity col-sm-6" (mouseover)="goalHover4 = true" (mouseout)="goalHover4 = false">
      <div class="productivity-icon" [@goalHover]="goalHover4 ? 'goal4Icon':'beforeHover'"></div>

      <div class="productivity-words" [@goalHover]="goalHover4 ? 'fontHover':'beforeHover'">
        <div class="productivity-title">
          <h4>Productivity</h4>
        </div>
  
        <div class="productivity-description">
          <p>The effectiveness of the quality management system will be continually improved! Quality products can be expected from us time to time.</p>
        </div> 
      </div>
    </div>

    <div class="protection col-sm-6" (mouseover)="goalHover5 = true" (mouseout)="goalHover5 = false">
      <div class="protection-icon" [@goalHover]="goalHover5 ? 'goal5Icon':'beforeHover'"></div>

      <div class="protection-words" [@goalHover]="goalHover5 ? 'fontHover':'beforeHover'">
        <div class="protection-title">
          <h4>Safety</h4>
        </div>
  
        <div class="protection-description">
          <p>By understanding other industry requirements, our products quality are verified well from them in their production.</p>
        </div>  
      </div>
    </div>
  </div>
</div>

<!-- ***************************************************** Product & Services Section *************************************************** -->
<div #product class="section-services">
  <div class="section-title">
    <div class="services-title" [@movingIn]="products ? 'afterTitle':'beforeTitle'" #productSec>
      <h1>Products & Services</h1>
    </div>
  </div>

  <div class="section-detail">
    <div class="smr-rubber">
      <div class="smr-content">
        <div class="smr-img col-sm-6" #smrRubber></div>
        
        <div class="smr-grades col-sm-6">
          <h3 style="font-weight: bold;">Standard Malaysian Rubber (SMR)</h3>
          <h4>Available Grades:</h4>
          <ul class="smr-list">
            <li>SMR 10</li>
            <li>SMR 20</li>
            <li>SMR 10CV</li>
            <li>SMR 20CV</li>
            <li>SMR 10 9710</li>
            <li>SMR GP</li>
          </ul>

          <div class="smr-button" (click)="collapseExpand('smrTable')">Specification</div>
        </div>
      </div>
      
      <div class="smr-spec-table" [@divCollapsed]="{value: collapseString, params:{divHeight: expandHeight}}" #smrTable>   
        <h3>Standard Malaysian Rubber (SMR) Specification for Grading Purposes since 01/2018</h3>   
        <table class="smr-table">
          <thead>
            <tr>
              <th rowspan="2" class="rubber-parameter" style="text-align: center; border-radius: 10px 0 0 0; border-left: none; z-index: 1;">Parameters</th>
              <th class="rubber-types">SMR CV60</th>
              <th class="rubber-types">SMR CV50</th>
              <th class="rubber-types">SMR L</th>
              <th class="rubber-types">SMR 5</th>
              <th class="rubber-types">SMR GP</th>
              <th class="rubber-types">SMR 10CV</th>
              <th class="rubber-types">SMR 10</th>
              <th class="rubber-types">SMR 20CV</th>
              <th class="rubber-types" style="border-radius: 0 10px 0 0;">SMR 20</th>
            </tr>
            
            <tr>
              <th colspan="3" class="rubber-types">Latex</th>
              <th class="rubber-types">Sheet Material</th>
              <th class="rubber-types">60% Sheet Material + 40% Field Grade</th>
              <th colspan="4" class="rubber-types">Field Grade Material</th>
            </tr>
          </thead>
          
          <tbody>
            <tr>
              <th class="rubber-parameter">Dirt retained on 44μm aperture, (Max, %wt)</th>
              <td>0.02</td>
              <td>0.02</td>
              <td>0.02</td>
              <td>0.05</td>
              <td>0.08</td>
              <td>0.08</td>
              <td>0.08</td>
              <td>0.16</td>
              <td>0.16</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter">Ash Content (Max, %wt)</th>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.6</td>
              <td>0.75</td>
              <td>0.75</td>
              <td>0.75</td>
              <td>1.00</td>
              <td>1.00</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter">Nitrogen</th>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
  
            <tr>
              <th class="rubber-parameter left-indent">(min. %wt)</th>
              <td>0.15</td>
              <td>0.15</td>
              <td>0.15</td>
              <td>0.15</td>
              <td>0.15</td>
              <td>0.15</td>
              <td>0.15</td>
              <td>0.15</td>
              <td>0.15</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter left-indent">(max, %wt)</th>
              <td>0.55</td>
              <td>0.55</td>
              <td>0.55</td>
              <td>0.55</td>
              <td>0.55</td>
              <td>0.55</td>
              <td>0.55</td>
              <td>0.55</td>
              <td>0.55</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter">Volatile Matter, VM (max, %wt)</th>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
              <td>0.5</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter">Plasticity</th>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
  
            <tr>
              <th class="rubber-parameter">Initial Plasticity (P<sub>o</sub>), (min)</th>
              <td>-</td>
              <td>-</td>
              <td>35</td>
              <td>30</td>
              <td>-</td>
              <td>-</td>
              <td>30</td>
              <td>-</td>
              <td>30</td>  
            </tr>
            
            <tr>
              <th class="rubber-parameter left-indent">Plasticity Retention Index (PRI), (min)</th>
              <td>≥60</td>
              <td>≥60</td>
              <td>≥60</td>
              <td>≥60</td>
              <td>≥50</td>
              <td>≥50</td>
              <td>≥50</td>
              <td>≥40</td>
              <td>≥40</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter left-indent">Mean value of PRI (min)</th>
              <td>≥70</td>
              <td>≥70</td>
              <td>≥70</td>
              <td>≥70</td>
              <td>≥60</td>
              <td>≥60</td>
              <td>≥60</td>
              <td>≥50</td>
              <td>≥50</td>  
            </tr>
  
            <tr>
              <th class="rubber-parameter">Lovibond Colour</th>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
  
            <tr>
              <th class="rubber-parameter left-indent">Individual Value (max)</th>
              <td>-</td>
              <td>-</td>
              <td>6</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter left-indent">Range (max)</th>
              <td>-</td>
              <td>-</td>
              <td>2</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter">Mooney Viscosity<br><span style="padding-left: 30px;">ML(1' + 4') 100°C</span></th>  
              <td>60 (+5, -5)</td>
              <td>50 (+5, -5)</td>
              <td>-</td>
              <td>-</td>
              <td>65 (+7, -5)</td>
              <td>60 (+7, -5)</td>
              <td>-</td>
              <td>65 (+7, -5)</td>
              <td>-</td>
            </tr>
  
            <tr>
              <th class="rubber-parameter">Cure</th>
              <td>R</td>
              <td>R</td>
              <td>R</td>
              <td>-</td>
              <td>R</td>
              <td>R</td>
              <td>-</td>
              <td>R</td>
              <td>-</td>  
            </tr>
  
            <tr>
              <th class="rubber-parameter">WASHT, ΔP</th>
              <td>≤8</td>
              <td>≤8</td>
              <td>-</td>
              <td>-</td>
              <td>≤8*</td>
              <td>≤8*</td>
              <td>-</td>
              <td>≤8*</td>
              <td>-</td>
            </tr>
          </tbody>
  
          <tr class="table-description">
            <td colspan="10" style="text-align: left; padding: 8px 0 10px 15px; border-radius: 0 0 10px 10px;">*Conduct MASHT if 6 < ΔP ≤ 8
              <br><br>
              <span style="padding-right: 1.9em;">R</span>- Curable (based on rheograph)<br>
              <span style="padding-right: 1.3em;">CV</span>- Constant Viscosity<br>
              <span style="padding-right: 2em;">L</span>- Light<br>
              <span style="padding-right: 1.3em;">GP</span>- General Purpose
            </td>  
          </tr>    
        </table>
      </div>
    </div>

    <div class="hgr-rubber">
      <div class="hgr-detail col-sm-6">
        <h3 style="font-weight: bold;">Mixture Rubber</h3>
        <p>Feeling that SMR Specification isn't right to your needs? Customize yours now!</p> 
        <p>We accept custom specification request from customers!</p>
        
        <div class="hgr-button" (click)="scroll(contact)">Contact Us</div>
        
        <p class="hgr-tnc">*Terms & conditions applied</p>
      </div>  

      <div class="hgr-img col-sm-6"></div>
    </div>
    
  </div>
</div>

<!-- ******************************************************* Sustainability Section ***************************************************** -->

<div #sustainability class="section-sustainability" [@heightFit]="{value: sustainabilityTabStatus, params:{sustainHeight: sustainHeight}}">
  <div class="sustainability-title">
    <div class="sustainability-header" [@movingIn]="sustain ? 'afterTitle':'beforeTitle'" #sustainabilitySec>
      <h1>Sustainability</h1>  
    </div>
      
    <div class="sustainability-intro" [@movingIn]="sustainIntro ? 'afterSec':'beforeSec'" #sustainabilityIntro>
      <div class="sustainability-environment col-sm-4" (mouseover)="envHover = true" (mouseout)="envHover = false">
        <div class="sustainability-environment-icon" [@sustainChange]="envHover ? 'hoverEnvironmentIcon':'before'"></div>
        <div class="sustainability-environment-title" [@sustainChange]="envHover ? 'hoverEnvironmentFont':'before'">
          <h3>Environment Green</h3>
        </div>

        <div class="sustainability-environment-description">
          <p>Not only the economic sustainability is vital in rubber manufacturing but also environmental sustainability. 
            While we are nurturing the economic growth, environment health has been considered with our environmental 
            initiatives</p>
          <!-- <p>We had achieved to minimize the polutant exposure since 2018.</p> 
          <p>Biological Industrial Effluent Treatment System and Scrubber have been used to maintain the water and air quality before discharge out.
          </p> -->
        </div>
      </div>

      <div class="sustainability-social col-sm-4" (mouseover)="socialHover = true" (mouseout)="socialHover = false">
        <div class="sustainability-social-icon" [@sustainChange]="socialHover ? 'hoverSocialIcon':'before'"></div>
        
        <div class="sustainability-social-title" [@sustainChange]="socialHover ? 'hoverSocialFont':'before'">
          <h3>Human Rights & Labor Practices</h3>
        </div>

        <div class="sustainability-social-description">
          <p>We recognize our employees as the core in manufacturing quality product; Both international standards of 
            human right and fundamental labor rights are practiced to assure their physical and mental are always
            in their best forms.</p>
          <!-- <p>We practice E=mc² while we work!</p>
          <p>Employee = Managerial * Comprehensive * Confident</p> -->
        </div>
      </div>

      <div class="sustainability-economy col-sm-4" (mouseover)="ecoHover = true" (mouseout)="ecoHover = false">
        <div class="sustainability-economy-icon" [@sustainChange]="ecoHover ? 'hoverEconomyIcon':'before'"></div>
        
        <div class="sustainability-economy-title" [@sustainChange]="ecoHover ? 'hoverEconomyFont':'before'">
          <h3>Supply Chain Management</h3>  
        </div>
        
        <div class="sustainability-economy-description">
          <p>We believe that not only us but also the suppliers are responsible in social and environmental practices
            responsibly. We do communicate with them, educating and encouraging them to adopt in these responsibilities
            and mitigating related risks that might happen.</p>
          <!-- <p>~99% acknowledgement from the suppliers on the Sustainable Procurement Policy and Sustainability Policy.</p> -->
        </div>
      </div>
    </div>
    
    <div class="sustainability-milestones">
      <h1>Milestones</h1>  
    </div>

    <div class="sustainability-tabs">
      <ul class="nav nav-tabs">
        <li [class.active]="sustainabilityTab == 'tab1'"><a (click)="sustainabilityTabSwitch('achievedTab')" data-toggle="tab" href="#achieved">Achieved Targets</a></li>
        <li [class.active]="sustainabilityTab == 'tab2'"><a (click)="sustainabilityTabSwitch('futureTab')" data-toggle="tab" href="#future">Future Targets</a></li>
      </ul>

      <div class="tab-content" [ngSwitch]="sustainabilityTab">
        <app-sustainability-achieved class="tab" id="achieved" *ngSwitchCase="'tab1'"></app-sustainability-achieved>  
        <app-sustainability-future class="tab" id="future" *ngSwitchCase="'tab2'"></app-sustainability-future>  
      </div>
    </div>

    <!-- <div class="sustainability-tabs">
      <ul class="nav nav-tabs">
        <li class="active"><a (click)="achievedSelect = true" data-toggle="tab" href="#achieved" [@tabOnSelect]="achievedSelect ? 'activeTab':'inactiveTab'">Achieved Targets</a></li>
        <li><a (click)="achievedSelect = false" data-toggle="tab" href="#future" [@tabOnSelect]="achievedSelect ? 'inactiveTab':'activeTab'">Future Targets</a></li>
      </ul>

      <div class="tab-content">
        <app-sustainability-achieved class="tab-pane fade-in active" id="achieved" [achievedStatus]="achievedSelect"></app-sustainability-achieved>  
        <app-sustainability-future class="tab-pane fade" id="future"></app-sustainability-future>  
      </div>
    </div> -->
  </div>
</div>

<!-- ********************************************************** Contact Section ********************************************************* -->

<div #contact class="section-contact">
  <div class="contact-title" [@movingIn]="contacts ? 'afterTitle':'beforeTitle'" #contactSec>
    <h1>Contact Us</h1>  
  </div>

  <div class="contact-brief">
    <h2>Contact us now! We will keep in touch with you within next 72 hours!</h2>  
  </div>

  <div class="contact-detail">
    <div class="contact-method-1 col-sm-4">
      <div class="contact-number" (mouseover)="contactNumberHover = true" (mouseout)="contactNumberHover = false">
        <div class="number-icon"></div>
        <div class="number-description">
          <h1>Contact Numbers</h1>
        </div>

        <div class="number-hidden" [@contactHover]="contactNumberHover ? 'after':'befLeft'">
          <h2>Contact Numbers</h2>
          
          <div class="number-table">
            <table class="contact-number-table">
              <tr>
                <th>Office</th>
                <td>: (+60) 9-960 1348</td>
              </tr>
              <tr>
                <th>Fax</th>
                <td>: (+60) 9-960 3401</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="contact-method-2 col-sm-4">
      <div class="contact-email" (mouseover)="contactEmailHover = true" (mouseout)="contactEmailHover = false">
        <div class="email-icon"></div>
        <div class="email-description">
          <h1>Emails</h1>
        </div>

        <div class="email-hidden" [@contactHover]="contactEmailHover ? 'after':'befMid'">
          <h2>Emails</h2>

          <div class="email-table">
            <table class="contact-email-table">
              <tr>
                <th>Sales</th>
                <td>: sales@senghinrubber.com</td>
              </tr>
              <tr>
                <th>Finance</th>
                <td>: finance@senghinrubber.com</td>
              </tr>
              <tr>
                <th>Shipping</th>
                <td>: shipping@senghinrubber.com</td>
              </tr>
              <tr>
                <th>Lab</th>
                <td>: lab@senghinrubber.com</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="contact-method-3 col-sm-4">
      <div class="contact-media" (mouseover)="contactMediaHover = true" (mouseout)="contactMediaHover = false">
        <div class="media-icon"></div>
        <div class="media-description">
          <h1>Social Media</h1>
        </div>

        <div class="media-hidden" [@contactHover]="contactMediaHover ? 'after':'befRight'">
          <h2>Social Media</h2>

          <div class="media-networks">
            <div class="facebook-media col-sm-6">
              <a href="https://www.facebook.com/pages/Seng-Hin-Rubber-M-Sdn-Bhd/421439151296044" target="_blank">
                <img class="contact-facebook" src="assets/images/facebook-icon-2.png">
              </a>
            </div>
            
            <div class="linkedin-media col-sm-6">
              <a href="https://www.linkedin.com/in/lee-seng-pin-28ba90129/?originalSubdomain=my" target="_blank">
                <img class="contact-linkedin" src="assets/images/linkedin-icon.png">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ********************************************************** Location Section ******************************************************** -->

<div #location class="section-location">
  <div class="location-title" [@movingIn]="locations ? 'afterTitle':'beforeTitle'" #locationSec>
    <h1>Location</h1>  
  </div>

  <div class="location-detail col-sm-6">
    <div class="location-brief">
      <h2>We welcome you whenever you are ready to find us!</h2>  
    </div>

    <div class="location-detail-2">
      <div class="location-address">
        <p><span class="glyphicon glyphicon-map-marker"></span> Seng Hin Rubber (M) Sdn. Bhd,</p>
        <p style="text-indent: 20px;">Kawasan Perindustrian Sg. Nal, Jalan Stapunal,</p>
        <p style="text-indent: 20px;">18000 Kuala Krai, Kelantan,</p>
        <p style="text-indent: 20px;">Malaysia.</p>
      </div>

      <div class="location-working-hours">
        <br>
        <p><span class="glyphicon glyphicon-briefcase"></span> 8.30am - 5.00pm (Sat - Thurs)</p>
      </div>

      <div class="direction-icon">
        <p>Get Direction: <span><div class="google-icon" (click)="redirectToMap()"></div></span>
        <span><div class="waze-icon" (click)="redirectToWaze()"></div></span></p>
      </div>
    </div> 
  </div>

  <div class="location-map col-sm-6" [@movingIn]="mapOnScreen ? 'after1':'before'" #map>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3970.7495771049403!2d102.20309351476614!3d5.60396259593732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31b67c65dab888fb%3A0x2bce9695bd828e41!2sSeng%20Hin%20Rubber%20(M)%20Sdn.%20Bhd.!5e0!3m2!1sen!2smy!4v1615343589893!5m2!1sen!2smy" allowfullscreen="" loading="lazy"></iframe>
  </div>
</div>

<!-- *********************************************************** Footer Section ********************************************************* -->
<div class="footer">
    <div class="container">
      <div class="logo">
        <div class="col-sm-3">
          <a (click)="scroll(introSec)"><div class="company-logo"></div></a>
          <div class="footer-iso">
            <div class="footer-EcoVadis"></div>
            <div class="footer-LRQA"></div>
            <div class="footer-ilac"></div>
            <!-- <img class="footer-LRQA" src="assets/images/Logo/LRQA-white.png" width="38%"> -->
            <!-- <img class="footer-ilac" src="assets/images/Logo/Cert-Latest-White.png" width="58%"> -->
          </div>
        </div>
      </div>
      <div class="footer-content-2">
        <div class="quick-link-tab col-sm-2">
          <table>
            <tr>
              <th>Quick Link</th>
            </tr>
            <tr>
              <td><a (click)="scroll(about)">About</a></td>
            </tr>
            <tr>
              <td><a (click)="scroll(product)">Product</a></td>
            </tr>
            <tr>
              <td><a (click)="scroll(sustainability)">Sustainability</a></td>
            </tr>
            <tr>
              <td><a (click)="scroll(contact)">Contact Us</a></td>
            </tr>
          </table>
        </div>
  
        <div class="contact-tab col-sm-4">
          <table>
            <tr>
              <th colspan="2">Contact</th>
            </tr>
            <tr>
              <td>Email</td>
              <td>: admin@senghinrubber.com</td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>: (+60) 9-960 1348</td>
            </tr>
            <tr>
              <td>Fax</td>
              <td>: (+60) 9-960 3401</td>
            </tr>
          </table>
          <div class="table-icon">
            <table>
              <tr>
                <td>
                  <div class="facebook-icon" (click)="redirectToFb()"></div>
                </td>
                <td>
                  <div class="linkedin-icon" (click)="redirectToLink()"></div>
                </td>
              </tr>
            </table>
          </div>
        </div>
  
        <div class="location-tab col-sm-3">
          <table>
            <tr>
              <th>Location</th>
            </tr>
            <tr>
              <td><a (click)="scroll(location)">Map</a></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  
    <div class="copyright-section">
      <p><span class="copyright-name">©2023 Seng Hin Rubber (M) Sdn. Bhd.</span> All rights reserved.</p>
    </div>
  </div>
  